module.exports = __webpack_public_path__ + "img/마포대교.4649498b.png";